import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import AddGiftCardForm from '@/common/customer.gift-card/AddGiftCardForm';

import ModalHeader from '../common/modal/header';
import ModalFooter from '../common/modal/footer';

const SubmitLayout = ({ children }) => (
    <ModalFooter>
        <ModalFooter.Right>{children}</ModalFooter.Right>
    </ModalFooter>
);

SubmitLayout.propTypes = {
    children: PropTypes.element.isRequired,
};

const CustomerGiftCard = ({ closeModal }) => {
    const [t] = useTranslation('gift-card');
    return (
        <div>
            <ModalHeader
                headerText={t('title_add_card')}
                onClose={closeModal}
            />
            <AddGiftCardForm
                onAddSuccess={closeModal}
                SubmitLayout={SubmitLayout}
                classNames={{
                    fields: 'm2g-modal-body',
                    instructionsContainer: 'm2g-form-element-group',
                    inputContainer:
                        'm2g-input-container m2g-form-element--full-width',
                    errorsContainer: 'm2g-form-element-group',
                    errors: 'm2g-error',
                    input: 'm2g-input m2g-form-element--full-width',
                }}
            />
        </div>
    );
};

CustomerGiftCard.propTypes = {
    closeModal: PropTypes.func.isRequired,
};

export default CustomerGiftCard;
